export default "__VITE_ASSET__ab704f0b__"